<template>
  <div>
    <main-layout :ResizeCallback="resize">
      <div class="tabContainer" v-bind:style="{'max-width':this.tableau_width+'px'}">
        <tableau-toolbar :viz="tableau_viz" :visibility="tableau_toolbar_visible">
        </tableau-toolbar>
        <div class="el-collapse" v-loading="loading">
          <div class="el-collapse-item" v-bind:style="{'max-width':this.tableau_width+'px'}" :class="{'is-active': filter_collapse == false}">
            <div class="collapse-item__header" @click="collapseFilter()">
              <i class="el-collapse-item__header__arrow el-icon-arrow-right"></i>Filters
            </div>
            <div>
              <div class="collapse-item__content" :class="{hidden: filter_collapse == true}">
                <div style="margin-top:10px">
                  <el-row v-for="(row, rowIndex) in this.listToMatrix(parameterData,parameterColumn)">
                    <el-col :span="6" v-for="(parameter,parameterIndex) in row">
                      <template v-if="parameter.type=='multiple'">
                        <multi-select :data="parameter" :callback="parameterCallback"></multi-select>
                      </template>
                      <template v-else-if="parameter.type=='single'">
                        <single-select :data="parameter" :callback="parameterCallback"></single-select>
                      </template>
                      <template v-else>
                        <div><br></div>
                      </template>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="18">
                      <br>
                    </el-col>
                    <el-col :span="6">
                      <el-button size="small" type="primary" style="float:right;margin-top:10px;margin-right:18px;width:180px;font-family:'Tableau Medium', Tableau, Arial, sans-serif;"
                        :disabled="applyfilter_button_clicked == true" @click="click_applyfilter()">Apply Filters</el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="vizContainer" ref="vizContainer" v-bind:style="{'padding-top':'1px', 'height': this.reportHeight+'px','min-height':this.reportMinHeight+'px','overflow-x':'auto', 'overflow-y':'hidden'}"></div>
      </div>
    </main-layout>
  </div>
</template>
<style scoped>
  .tabContainer {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    min-width: 1000px;
    max-width: 1280px;
  }
  
  .collapse-item__header {
    height: 33px;
    line-height: 33px;
    padding-left: 15px;
    color: #48576a;
    cursor: pointer;
    border-bottom: 1px solid #dfe6ec;
    font-size: 13px;
    background: #fafafa;
  }
  
  .collapse-item__content {
    font-family: "Tableau Medium", Tableau, Arial, sans-serif;
    font-size: 12px;
    padding: 5px 8px 10px 8px;
    color: #1f2d3d;
    line-height: 1.769230769230769;
  }
  
  .el-row {
    padding-left: 5px;
    height: 39px;
  }
</style>
<script>
import * as api from "../api";
import MainLayout from "../components/MainLayout.vue";
import config from "../../config";
import tableau from "tableau-api";
import TableauToolbar from "../components/TableauToolbar.vue"
import MultiSelect from "../components/MultiSelect.vue"
import SingleSelect from "../components/SingleSelect.vue"

export default {
  data() {
    return {
      tableau_viz: {},
      tableau_width:1200,
      tableau_toolbar_visible: "hidden",
	    reportHeight: this.getSize(),
      reportMinHeight: this.getSize(),
      filter_collapse: false,
      applyfilter_button_clicked: false,
      parameterData:[],
      parameterColumn:3,
      loading: false
    }
  },
  created: function() {
    document.body.scrollTop = 0;
  },
  methods: {
    getSize: function() {
      return window.innerHeight - 165;
    },
    resize: function() {
      let height = this.getSize();
      this.reportHeight = height <= 250 ? 250 : height;
    },
    collapseFilter: function(){
      this.filter_collapse = !this.filter_collapse
    },
    parameterCallback: function(parameter){
        var _self = this
        let path = this.$store.state.route.query.path;
        api.postParameter(path, parameter, _self.parameterData).then(
          response => {
              _self.parameterData = response.body.parameterData
          },
          response => {
            console.log(response);
         });
    },
    listToMatrix: function(list, elementsPerSubArray) {
      var matrix = [], i, k;
      for (i = 0, k = -1; i < list.length; i++) {
          if (i % elementsPerSubArray === 0) {
              k++;
              matrix[k] = [];
          }
          matrix[k].push(list[i]);
      }
      return matrix;
    },
    build_queryString: function(){
      let queryString = ""
      for(var i=0,j=0;i<this.parameterData.length;i++){
        var data = this.parameterData[i]
        if(data.filtername.indexOf("fake")>0){
          continue
        }
        j++
        if(data.checkedFilters.length > 0){
          if(j>1){
            queryString += "&"
          }
          queryString += data.filtername + "="
          for(var j=0;j<data.checkedFilters.length;j++){
            if(j>0){
              queryString += ","
            }
            queryString += data.checkedFilters[j] == 'Null' ? "~~null~" : escape(data.checkedFilters[j])
          }
        }
      }
      return queryString
    },
    applyFilters: function(sheet){
      let _self = this
      for(var i=0;i<_self.parameterData.length;i++){
        var parameter = _self.parameterData[i]
        sheet.applyFilterAsync(parameter.filtername, parameter.checkedFilters, 'REPLACE')
        .then(function(){
          console.log(parameter.displayname + ' applied')
        });
      }
    },
    click_applyfilter: function(){
      let _self = this
      let selected_parameter = 0
      for(var i=0;i<_self.parameterData.length;i++){
        var parameter = _self.parameterData[i]
        selected_parameter += parameter.checkedFilters.length
        if(parameter.name != 'placeholder' && parameter.checkedFilters.length == 0){
          _self.$message.error('Please select filters for ' + parameter.displayname)
          return
        }
      }

      // console.log('selected parameter number: ' + selected_parameter)
      // if(selected_parameter >= 400){
      //   _self.$message.error('You selected two many filters, performance will be bad');
      //   return
      // }

      _self.applyfilter_button_clicked = true
      setTimeout(()=> {
        _self.applyfilter_button_clicked = false
      }, 10000)

      let baseUrl = config.get("TableauServer") +'/' + _self.$store.state.route.query.path
      _self.load_tableau(baseUrl)

    },
    get_checked_keys: function(parameter){
      var keys = []
      for(var i=0;i<parameter.checkedFilters.length;i++){
        var filter = parameter.checkedFilters[i]
        keys.push(parameter.keys[filter])
      }  
      return keys
    },
    load_tableau: function(tableauUrl){
      let _self = this;
      if(_self.tableau_viz && _self.tableau_viz.dispose){
        _self.tableau_viz.dispose()
      }
      var options = {
        usePublishedSize: true,
        toolbarPosition: "top",
        hideToolbar: true,
        onFirstVizSizeKnown: function (e) {
            if(e.$vizSize.sheetSize.maxSize != undefined && e.$vizSize.sheetSize.maxSize.width != 0){
                _self.tableau_width =  e.$vizSize.sheetSize.maxSize.width
            }
        }
      }

      for(var i=0;i<_self.parameterData.length;i++){
        var parameter = _self.parameterData[i]
        if(parameter.filtername.indexOf("fake") > 0 || parameter.checkedFilters.length == 0){
          continue
        }
        var obj = {}
        var checkedFilters = []
        for(var j=0;j<parameter.checkedFilters.length;j++){
          let filter = parameter.checkedFilters[j]
          let nfilter = filter == 'Null' ? "~~null~" : filter
          checkedFilters.push(nfilter)
        }
        if(parameter.usekey == '1'){
          var checkedKeys = _self.get_checked_keys(parameter)
          obj[parameter.filtername] = parameter.type=='single' ? checkedKeys[0] : checkedKeys
        }
        else{
          obj[parameter.filtername] = parameter.type=='single' ? checkedFilters[0] : checkedFilters
        }
        Object.assign(options, obj)
      }

      _self.tableau_viz = new tableau.Viz(
        this.$refs.vizContainer,
        tableauUrl,
        options
      )
      window.Viz = _self.tableau_viz

      _self.tableau_viz.addEventListener("customviewload", function() {
        _self.reportMinHeight = _self.tableau_viz._impl.$vizSize.sheetSize.minSize.height + 18;
        _self.tableau_toolbar_visible = "visible"
        _self.$store.commit("tableau_login")
        _self.applyfilter_button_clicked = false
      });

    }
  },
  mounted: function() {
    var _self = this
    let path = this.$store.state.route.query.path;
    _self.loading = true
    api.getParameter(path).then(
      response => {
        _self.loading = false
        if(response.body.HasError){
          this.$message.error(response.body.ErrorMessage)
          return
        }
        _self.parameterData = response.body.parameterData
        _self.parameterColumn = response.body.parameterColumn
        let baseUrl = config.get("TableauServer") +'/' + _self.$store.state.route.query.path
        _self.load_tableau(baseUrl)
      },
      response => {
        console.log(response);
      }
    );
  },
  components: {
    MainLayout,
    TableauToolbar,
    MultiSelect,
    SingleSelect
  }
};
</script>


// WEBPACK FOOTER //
// TableauNew.vue?cc3d89bc